import styled from "styled-components";
import { ElementCell, ElementTable, PrimaryCell } from "../ElementTable";

export const PlayersTable = styled(ElementTable)`
  display: block;
  border-width: 0;

  thead,
  tbody {
    display: block;
    width: 100%;
  }

  tr {
    display: flex;
    align-items: center;
  }

  tbody tr {
    padding: ${({ theme }) => theme.space[2]};
  }

  tbody td {
    padding: 0;
  }

  tbody td:first-child {
    padding: 0;
  }

  th,
  td {
    display: block;
  }

  thead tr {
    width: 100%;
  }

  th {
    flex: 1 0 100%;
    box-sizing: border-box;
    text-transform: uppercase;
  }
`;

export const PlayerCell = styled(ElementCell)`
  flex: 1;
  min-width: 0;
`;

export const RightCell = styled(PrimaryCell)`
  flex-shrink: 0;
  font-family: ${({ theme }) => theme.fonts.bold};
  text-align: end;
`;

export const GroupHeading = styled.th`
  font-size: ${({ theme }) => theme.fontSizes[1]};
  border-left: none;
  border-right: none;
`;

export const MoreLinkWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${({ theme }) => theme.space[2]};
`;

export const PlayerAvailabilityHeading = styled.h3`
  padding: ${({ theme }) => theme.space[1]};
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes[5]};
`;
